export default __webpack_public_path__ + "static/VehicleDetailWithAdds-ac8e0e6ec553e2f976e3b67f33bc9509.jpg";